import {
  FiHome,
  FiShoppingCart,
  FiUsers,
  FiGrid,
  FiImage,
  FiBarChart2,
  FiLayers,
  FiSend,
} from "react-icons/fi";

import MainPage from "./pages/main/main";
import Trades from "./pages/trades/trade";
import Messages from "./pages/users/users.page";
import CategoriesPage from "./pages/categories/categories.page";
import Banners from "./pages/incomes/incomes";
import Products from "./pages/outcomes/outcomes";
import TestReportPage from "./pages/test-report/report";
import TelegramBotPage from "./pages/telegramBot/telegrambot.page";
import WarehousesPage from "./pages/warehouses/warehouses.page";
import ErrorPage from "./pages/error/error";

/**
 * Yon paneldagi bo'limlar.
 *
 * Guruhlar bezak emas -- ular haqiqiy sohalarni ajratadi: kundalik savdo,
 * tovar ma'lumotnomasi va tizim sozlamalari. Xodim qaysi guruhda ishlayotganini
 * bilsa, keraksiz bo'limlarni o'qimaydi.
 *
 * `roles` -- shu bo'limni ko'ra oladigan rollar. Bo'sh bo'lsa hamma ko'radi.
 * Ilgari bu ro'yxat modul yuklanganda bir marta hisoblanardi, ya'ni kirgandan
 * keyin sahifa yangilanmaguncha eski huquqlar qolib ketardi.
 */
const routes = [
  {
    path: "/",
    exact: true,
    component: <MainPage />,
    name: "Boshqaruv",
    group: "Savdo",
    icon: <FiHome />,
    roles: [],
  },
  {
    path: "/trades",
    exact: true,
    component: <Trades />,
    name: "Buyurtmalar",
    group: "Savdo",
    icon: <FiShoppingCart />,
    roles: ["ADMIN", "DIRECTOR", "MODERATOR", "SELLER"],
  },
  {
    path: "/reports",
    exact: true,
    component: <TestReportPage />,
    name: "Hisobotlar",
    group: "Savdo",
    icon: <FiBarChart2 />,
    roles: ["ADMIN", "DIRECTOR", "MODERATOR", "SELLER"],
  },

  {
    path: "/products",
    exact: true,
    component: <Products />,
    name: "Tovar rasmlari",
    group: "Katalog",
    icon: <FiImage />,
    roles: ["ADMIN", "DIRECTOR", "MODERATOR", "PHOTO_ADMIN"],
  },
  {
    path: "/categories",
    exact: true,
    component: <CategoriesPage />,
    name: "Kategoriyalar",
    group: "Katalog",
    icon: <FiGrid />,
    roles: ["ADMIN", "DIRECTOR", "MODERATOR"],
  },
  {
    path: "/warehouses",
    exact: true,
    component: <WarehousesPage />,
    name: "Omborlar",
    group: "Katalog",
    icon: <FiLayers />,
    roles: ["ADMIN", "DIRECTOR", "MODERATOR"],
  },
  {
    path: "/banner",
    component: <Banners />,
    name: "Bannerlar",
    group: "Katalog",
    icon: <FiImage />,
    roles: ["ADMIN", "DIRECTOR", "MODERATOR"],
  },

  {
    path: "/users",
    exact: true,
    component: <Messages />,
    name: "Foydalanuvchilar",
    group: "Tizim",
    icon: <FiUsers />,
    roles: ["ADMIN", "DIRECTOR", ],
  },
  {
    path: "/telegrambot",
    exact: true,
    component: <TelegramBotPage />,
    name: "Telegram bot",
    group: "Tizim",
    icon: <FiSend />,
    roles: ["ADMIN", "DIRECTOR", "MODERATOR"],
  },

  {
    path: "/error",
    component: <ErrorPage />,
    name: "Xato",
    hide: true,
    roles: [],
  },
];

/** Guruhlar tartibi -- yon panelda shu ketma-ketlikda chiqadi. */
export const groupOrder = ["Savdo", "Katalog", "Tizim"];

/** Foydalanuvchi shu bo'limni ko'ra oladimi. */
export const canUse = (route, user) => {
  if (route.hide) return false;
  if (!route.roles || route.roles.length === 0) return true;
  return Boolean(user) && route.roles.includes(user.role);
};

export default routes;
